import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import {
  megaMenuMetaobjects,
  getMegaMenusBannerMetaobjects,
} from '../utils/storefront/queries';
import Storefront from '../utils/storefront';
import {
  formatMegaMenus,
  formatMegaMenusBanners,
} from '../utils/storefront/format-resource';
import MobileMenuList from './mobile-menu-list';
import { getBannerMedia } from './utils';

const MobileSubMenuTabItems = ({ menu, activeSubMenuLink = false }) => {
  const neededMenus = menu?.map((m) => ({ title: m.title, url: m.url }));
  const neededMenusBanners = menu?.filter((m) => m.title.includes('#banner'));
  const storefront = new Storefront();
  const [megaMenus, setMegaMenus] = useState(null);
  const [megaMenusBanners, setMegaMenusBanners] = useState(null);

  useEffect(() => {
    const getMegaMenus = async () => {
      try {
        const response = await storefront.request({
          query: megaMenuMetaobjects,
          variables: {
            countryCode: window.TMW.localization.countryCode,
            languageCode: window.TMW.localization.languageCode,
          },
        });

        const formattedMegaMenus = formatMegaMenus(response, neededMenus);

        setMegaMenus(formattedMegaMenus);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    const getMegaMenusBanners = async () => {
      try {
        const response = await storefront.request({
          query: getMegaMenusBannerMetaobjects('mega_menu_banners'),
          variables: {
            countryCode: window.TMW.localization.countryCode,
            languageCode: window.TMW.localization.languageCode,
          },
        });

        const formattedMegaMenusBanners = formatMegaMenusBanners(
          response,
          neededMenusBanners,
        );

        setMegaMenusBanners(formattedMegaMenusBanners);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    getMegaMenus();
    getMegaMenusBanners();
  }, [menu]);

  return (
    <>
      <div className="flex flex-col items-start justify-start w-full">
        {megaMenus?.length > 0 &&
          megaMenus?.map((menuList) => {
            const isFeatured = menuList.handle === 'Featured';
            if (isFeatured) {
              return (
                <div key={menuList.handle} className="p-5 order-2 w-full">
                  <p className="font-14-bold text-black mb-5">
                    {menuList.handle}
                  </p>
                  <ul>
                    {menuList.links.length > 0 &&
                      menuList.links.map((link) => (
                        <li key={link.label} className="mb-5">
                          <a href={link.url} className="font-14 text-charcoal">
                            {link.label}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              );
            }
            return <MobileMenuList menuList={menuList} key={menuList.handle} />;
          })}
        {activeSubMenuLink && activeSubMenuLink.url !== '#' && (
          <div className="p-5 order-1 w-full">
            <div className="bg-cream-grey text-center w-full pt-[18px] pb-5">
              <a
                href={activeSubMenuLink.url}
                className="text-black cta-small uppercase underline"
              >
                {window.TMW?.Strings?.header?.shopAll} {activeSubMenuLink.title}
              </a>
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col items-start justify-start px-5 pt-5">
        {megaMenusBanners?.length > 0 &&
          megaMenusBanners?.map((banner) => (
            <div key={banner.title} className="w-full pb-10 text-center">
              {banner.url && (
                <a
                  href={banner.url}
                  className="mb-2.5 block link-unstyled"
                  target={banner.new_tab ? '_blank' : ''}
                  rel="noreferrer"
                >
                  {getBannerMedia({
                    ...banner,
                    isVoyages: false,
                    isDesktop: false,
                  })}
                </a>
              )}
              {!banner.url && getBannerMedia({
                    ...banner,
                    isVoyages: false,
                    isDesktop: false,
                  })}
              {banner.title && banner.url && (
                <a
                  href={banner.url}
                  target={banner.new_tab ? '_blank' : ''}
                  className="font-13 text-black underline block w-fit mx-auto"
                  rel="noreferrer"
                >
                  {banner.title}
                </a>
              )}
              {banner.title && !banner.url && (
                <p className="font-13 text-black block w-fit mx-auto">
                  {banner.title}
                </p>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default MobileSubMenuTabItems;
